export default function arraySplice<T>(items: T[], start: number, deleteCount: number, ...newItems: T[]): T[] {
    const copy = [...items];
    copy.splice(start, deleteCount, ...newItems);
    return copy;
}